import {
  Autocomplete,
  AutocompleteChangeReason,
  IconButton,
} from "@mui/material";
import { TextField } from "@mui/material";
import { Backdrop, CircularProgress } from "@mui/material";
import { SyntheticEvent, useEffect, useRef } from "react";
import { User } from "../../proto/api_pb";
import { mapToTalkUser } from "../../utils/TalkjsUtils";
import MessageIcon from "@mui/icons-material/Message";
import { backdropStyles, Row, SelectUserContainer, styles } from "./styles";
import { Props } from "./types";
import { useParams } from "react-router-dom";

export const Messages: React.FC<Props> = ({
  autoCompleteOptions,
  isChatLoading,
  setParticipants,
  createConversation,
  setInbox,
  session,
  isSmallScreen,
  autoCreateChat,
}) => {
  const { conversationId, conversationSubject } = useParams();
  const chatBoxEl = useRef<HTMLDivElement>(null);
  const handleAutocompleteChange = (
    _event: SyntheticEvent<Element, Event>,
    value: User[],
    _reason: AutocompleteChangeReason
  ) => {
    setParticipants(value.map(mapToTalkUser));
  };
  useEffect(() => {
    document.title = "OmMuse";
  }, []);

  useEffect(() => {
    if (session && session.getInboxes().length < 0) return;
    if (autoCreateChat) {
      createConversation(conversationId, conversationSubject);
    }
  }, [
    autoCreateChat,
    conversationId,
    conversationSubject,
    createConversation,
    session,
  ]);

  useEffect(() => {
    if (session) {
      const talkInbox = session.createInbox();
      setInbox(talkInbox);
      talkInbox.mount(chatBoxEl.current);
      if (conversationId && conversationSubject) {
        talkInbox.select(conversationId);
      }
    }
  }, [chatBoxEl, session, setInbox, conversationId, conversationSubject]);

  const classes = backdropStyles();

  return (
    <div className="container">
      <Row
        style={
          isSmallScreen === true
            ? { display: "block", margin: "-20px" }
            : { display: "flex" }
        }
      >
        {!isSmallScreen && (
          <SelectUserContainer>
            <Autocomplete
              multiple
              options={autoCompleteOptions}
              getOptionLabel={(option) => option.getUsername()}
              renderInput={(params) => (
                <TextField {...params} label="Select users" />
              )}
              onChange={handleAutocompleteChange}
              sx={styles.autoComplete}
            />
            <IconButton
              sx={{ color: "white" }}
              aria-label="edit"
              onClick={() => createConversation()}
            >
              <MessageIcon />
            </IconButton>
          </SelectUserContainer>
        )}
      </Row>
      <div
        className={classes.parent}
        ref={chatBoxEl}
        style={{
          width: "100%",
          height: isSmallScreen ? "75vh" : "80vh",
        }}
      >
        <Backdrop
          className={classes.backdrop}
          open={isChatLoading}
          invisible={false}
        >
          <CircularProgress color="primary" />
        </Backdrop>
      </div>
    </div>
  );
};
